// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/empty_image.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.advanced-settings-preview-map-container {
    width: 100%;
    height: 70vh;
    z-index: 0;
}

.forty-x-image {
    width: 600px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px;
    margin-top: 10px;
}

.blank-forty-x-image {
    width: 600px;
    height: 502px;
    border: 1px solid black;
    border-radius: 5px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 36px;
    font-weight: bold;
    padding: 30px;
    margin-top: 10px;
}

.actionable-div {
    width: 600px;
    text-align: center;
}

.actionable-div-left-align {
    width: 600px;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/workflow/advanced-preview-settings-component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,yDAAkD;IAClD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".advanced-settings-preview-map-container {\n    width: 100%;\n    height: 70vh;\n    z-index: 0;\n}\n\n.forty-x-image {\n    width: 600px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 30px;\n    margin-top: 10px;\n}\n\n.blank-forty-x-image {\n    width: 600px;\n    height: 502px;\n    border: 1px solid black;\n    border-radius: 5px;\n    background-image: url(\"../../img/empty_image.jpg\");\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 36px;\n    font-weight: bold;\n    padding: 30px;\n    margin-top: 10px;\n}\n\n.actionable-div {\n    width: 600px;\n    text-align: center;\n}\n\n.actionable-div-left-align {\n    width: 600px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
